import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter, useParams, useHistory } from "react-router-dom";

import {
  ROUTES,
  messages,
  customerConstants,
  eventBookingConstants,
} from "../../../../constants";
import { Images } from "../../../../assets/images";
import { NavigateToPath } from "../../../../system";
import { eventBookingActions } from "../../../../redux/actions/eventBooking.actions";

const ThankYou = (props) => {
  const history = useHistory();
  const { id, orderItemGroupId, isNewBooking, CheckoutStatus } = useParams();
  useEffect(() => {
    window.dataLayer.push({
      event: "site_action",
      action: "eventbookrequested",
    });
    if (id && orderItemGroupId && CheckoutStatus) {
      props.requestBooking(id, orderItemGroupId, CheckoutStatus);
      props.resetEventBooking();
      history.replace("/EventBookRequested");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="thank-you-page d-flex justify-content-center">
        <div className="thank-you-box text-center px-3 px-md-5 py-5">
          {props.eventRequested === "" ? (
            <h2 className="thank-you-heading h-100 d-flex justify-content-center align-items-center">
              processing....
            </h2>
          ) : props.eventRequested ? (
            <>
              <div className="check-icon mb-4">
                <img src={Images.TickMark} alt="" />
              </div>
              <h2 className="thank-you-heading mb-3">thank you!</h2>
              <p className="thank-you-text mb-4 px-1 px-md-5">
                {isNewBooking ===
                eventBookingConstants.IS_NEW_BOOKING.ADD_SHUTTERB
                  ? `your booking is complete and all the shutterbz are assigned to
                  the event.`
                  : `your payment has been processed. check your email for further
            details regarding your booking or other transactions made through
            our shutterb website.`}
              </p>
              <button
                className="my-event-btn button-common button-fill"
                onClick={() => NavigateToPath(history, ROUTES.MY_EVENTS_TAB)}
              >
                {messages.MY_EVENTS}
              </button>
            </>
          ) : (
            <h2 className="thank-you-heading  h-100 d-flex justify-content-center align-items-center">
              something went wrong
            </h2>
          )}
        </div>
      </div>
    </>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  eventRequested: state.eventBooking.eventRequested,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  requestBooking: (data, orderItemGroupId, CheckoutStatus) =>
    dispatch(
      eventBookingActions.requestBooking(data, orderItemGroupId, CheckoutStatus)
    ),
  setSelectedShutterBz: (data) =>
    dispatch(eventBookingActions.setSelectedShutterBz(data)),
  resetEventBooking: () => dispatch(eventBookingActions.resetEventBooking()),
  setCartTab: (isCartTab) =>
    dispatch(eventBookingActions.setCartTab(isCartTab)),
  setReelValues: (dataObj) =>
    dispatch({ type: eventBookingConstants.SET_REEL_VALUES, data: dataObj }),
  emptyEventBookingRed: () => {
    dispatch({ data: {}, type: eventBookingConstants.SET_FORM_STATE });
    dispatch({ data: [], type: eventBookingConstants.SELECTED_SHUTTER_BS });
    dispatch({ data: false, type: eventBookingConstants.SET_CART_TAB });
    dispatch({
      data: [],
      type: customerConstants.UPDATE_CUSTOMER_DASHBOARD_CART,
    });
  },
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ThankYou));
